import React from "react";
import { useNavigate } from "react-router-dom";
import { BRAND_COLOR } from "../../common/constants";

const GettingStarted = () => {
 const navigate = useNavigate();
 const isMobile = window.innerWidth <= 768;

 const steps = [
 {
 title: "Register",
 description:
 "Sign up for an account to access the full range of Speak Bold sessions and community features.",
 },
 {
 title: "Book a Session",
 description:
 "Choose a time that fits your schedule from the timetable page and reserve your spot for a live session.",
 },
 {
 title: "Join the Session",
 description:
 "Click the join button at your scheduled time. Interact with the host and other participants for a real conversation experience.",
 },
 {
 title: "Practice & Improve",
 description:
 "Use breakout sessions and 1-to-1 conversations to practice speaking. Track your progress and gain confidence over time.",
 },
 ];

 return (
 <div
 style={{
 width: "100%",
 padding: isMobile ? "40px 16px 60px" : "60px 20px 80px",
 backgroundColor: "#f5f6fa",
 }}
 >
 {/* ===== PAGE HEADER ===== */}
 <h1
 style={{
 textAlign: "center",
 marginBottom: 12,
 color: BRAND_COLOR,
 fontSize: isMobile ? 24 : 32,
 }}
 >
 Getting Started with Speak Bold
 </h1>

 <p
 style={{
 textAlign: "center",
 fontSize: isMobile ? 14.5 : 16,
 color: "#555",
 marginBottom: isMobile ? 32 : 40,
 maxWidth: 800,
 marginInline: "auto",
 lineHeight: 1.6,
 }}
 >
 Watch this quick video to understand how you can start building your
 confidence in English speaking through Speak Bold.
 </p>

 {/* ===== STEPS SECTION ===== */}
 <div
 style={{
 display: "grid",
 gridTemplateColumns: isMobile
 ? "1fr"
 : "repeat(auto-fit, minmax(250px, 1fr))",
 gap: isMobile ? 18 : 30,
 width: "100%",
 maxWidth: 1100,
 margin: "0 auto 60px",
 }}
 >
 {steps.map((step, idx) => (
 <div
 key={idx}
 style={{
 padding: isMobile ? 20 : 30,
 borderRadius: 14,
 backgroundColor: "#fff",
 textAlign: "center",
 transition: isMobile ? "none" : "all 0.3s ease",
 boxShadow: isMobile
 ? "0 4px 12px rgba(0,0,0,0.06)"
 : "0 6px 16px rgba(0,0,0,0.06)",
 }}
 onMouseEnter={(e) => {
 if (!isMobile) {
 e.currentTarget.style.transform = "translateY(-6px)";
 e.currentTarget.style.boxShadow =
 "0 14px 30px rgba(0,0,0,0.15)";
 e.currentTarget.style.backgroundColor = "#eef4ff";
 }
 }}
 onMouseLeave={(e) => {
 if (!isMobile) {
 e.currentTarget.style.transform = "translateY(0)";
 e.currentTarget.style.boxShadow =
 "0 6px 16px rgba(0,0,0,0.06)";
 e.currentTarget.style.backgroundColor = "#fff";
 }
 }}
 >
 <h3
 style={{
 marginBottom: 10,
 color: BRAND_COLOR,
 fontWeight: 600,
 fontSize: isMobile ? 17 : 20,
 }}
 >
 {step.title}
 </h3>

 <p
 style={{
 fontSize: isMobile ? 14 : 15,
 color: "#555",
 lineHeight: 1.6,
 }}
 >
 {step.description}
 </p>
 </div>
 ))}
 </div>

 {/* ===== BOTTOM CTA BUTTON ===== */}
 <div
 style={{
 display: "flex",
 justifyContent: "center",
 marginTop: 10,
 }}
 >
 <button
 onClick={() => navigate("/timetable")}
 style={{
 width: isMobile ? "100%" : "auto",
 maxWidth: 360,
 padding: isMobile ? "14px 20px" : "14px 32px",
 fontSize: isMobile ? 15 : 16,
 fontWeight: 600,
 backgroundColor: BRAND_COLOR,
 color: "#ffffff",
 border: `2px solid ${BRAND_COLOR}`,
 borderRadius: 30,
 cursor: "pointer",
 boxShadow: "0 10px 24px rgba(0,0,0,0.15)",
 transition: isMobile ? "none" : "all 0.3s ease",
 }}
 onMouseEnter={(e) => {
 if (!isMobile) {
 e.currentTarget.style.backgroundColor = "#ffffff";
 e.currentTarget.style.color = BRAND_COLOR;
 e.currentTarget.style.transform = "translateY(-2px)";
 e.currentTarget.style.boxShadow =
 "0 16px 30px rgba(0,0,0,0.2)";
 }
 }}
 onMouseLeave={(e) => {
 if (!isMobile) {
 e.currentTarget.style.backgroundColor = BRAND_COLOR;
 e.currentTarget.style.color = "#ffffff";
 e.currentTarget.style.transform = "translateY(0)";
 e.currentTarget.style.boxShadow =
 "0 10px 24px rgba(0,0,0,0.15)";
 }
 }}
 >
 Book a Live Session
 </button>
 </div>
 </div>
 );
};

export default GettingStarted;
